import { useHistory } from "react-router-dom";
import { ButtonVariant } from "@merge-api/merge-javascript-shared";
import ErrorPage from "./ErrorPage";
import MantaTeapot from "../../../assets/svg/merge-manta-418.svg";
import { INTEGRATION_DASHBOARD_PATH } from "../../../router/RouterUtils";

const TeapotPage = () => {
  // hooks
  const history = useHistory();

  // render
  return (
    <ErrorPage
      illustration={MantaTeapot}
      illustrationAlt="Merge Manta sipping a cup of tea"
      code="418"
      title="Just a little tea break"
      message="Even a manta needs a moment to steep"
      actionLabel="Go to Integrations"
      actionVariant={ButtonVariant.TextBlue}
      onAction={() => history.push(INTEGRATION_DASHBOARD_PATH)}
    />
  );
};

export default TeapotPage;
